<template>
  <div>nyitvatartás</div>
</template>
